export interface OpenModalType {
  typeModal: string
  modalProps?: any
}

interface InitModalState {
  isOpen: boolean
  data: any
}

export const initModalState: InitModalState = {
  isOpen: false,
  data: {},
}
